(() => {
  // app/scripts/cart-vehicle-identification.js
  var CartVehicleIdentification = class extends HTMLElement {
    connectedCallback() {
      this.vinInput = this.querySelector(".jsVinInput");
      this.btnEditVin = this.querySelector(".jsEditVin");
      this.btnDiscardChange = this.querySelector(".jsDiscardChangeVin");
      this.submitVin = this.querySelector(".jsSaveVin");
      this.messageArea = this.querySelector(".jsMessageArea");
      this.variantId = this.dataset.variantId;
      this.currentValue = this.dataset.currentValue;
      this.productId = this.dataset.productId;
      this.itemKey = this.dataset.itemKey;
      this.setupEventListeners();
    }
    setupEventListeners() {
      if (this.btnEditVin) {
        this.btnEditVin.addEventListener("click", (el) => {
          this.classList.add("active");
          this.vinInput.focus();
          this.vinInput.setSelectionRange(this.vinInput.value.length, this.vinInput.value.length);
        });
      }
      if (this.btnDiscardChange) {
        this.btnDiscardChange.addEventListener("click", (el) => {
          this.classList.remove("active");
          this.vinInput.blur();
        });
      }
      if (this.submitVin) {
        this.submitVin.addEventListener("click", (el) => {
          this.onSubmit();
        });
      }
    }
    validateInputValue() {
      var value = this.vinInput.value.trim();
      if (value === this.currentValue)
        return false;
      if (value === "")
        return true;
      const regex = /^[A-HJ-NPR-Z0-9]{17}$/i;
      return regex.test(value);
    }
    async getCartLineItem() {
      try {
        const response = await fetch("/cart.js");
        const cart = await response.json();
        const filteredLineItem = cart.items.filter((item) => item.key === this.itemKey);
        return filteredLineItem;
      } catch (error) {
        console.error("Failed to fetch cart:", error);
        return false;
      }
    }
    async updateCartLineItem(itemKey, quantity = 1, properties = {}) {
      try {
        let response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: itemKey,
            quantity,
            properties
          })
        });
        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(errorData?.description || `HTTP error! status: ${response.status}`);
        }
        return true;
      } catch (error) {
        console.error("Failed to add item to cart:", error);
        return false;
      }
    }
    async refreshCartSection() {
      try {
        let response = await fetch(`${location.pathname}?sections=main-cart`);
        response = await response.json();
        const doc = new DOMParser().parseFromString(response["main-cart"], "text/html");
        const currentCartForm = document.getElementById("cart");
        const newCartForm = doc.getElementById("cart");
        if (!currentCartForm || !newCartForm) {
          return false;
        }
        currentCartForm.innerHTML = newCartForm.innerHTML;
        return true;
      } catch (err) {
        console.error("Failed to refresh cart section:", err);
        return false;
      }
    }
    async onSubmit() {
      this.querySelectorAll(".form__invalid-value").forEach((el) => el.remove());
      const isValidated = this.validateInputValue();
      if (!isValidated) {
        this.messageArea.innerHTML = `<div class="form__invalid-value">Please enter a valid value</div>`;
        return;
      }
      this.submitVin.innerHTML = "Submitting..";
      this.submitVin.setAttribute("disabled", true);
      const currentLineItem = await this.getCartLineItem();
      if (!currentLineItem || currentLineItem.length === 0)
        return;
      const currentProperties = currentLineItem[0].properties;
      const vinValue = this.vinInput.value.trim();
      const newProperties = { ...currentProperties };
      if (vinValue) {
        newProperties["Vehicle Identification Number"] = vinValue;
      } else {
        delete newProperties["Vehicle Identification Number"];
      }
      const updated = await this.updateCartLineItem(currentLineItem[0].key, currentLineItem[0].quantity, newProperties);
      if (!updated) {
        this.messageArea.innerHTML = `<div class="form__invalid-value">Something went wrong. Please try again later!</div>`;
        this.submitVin.innerHTML = "Submit";
        this.submitVin.removeAttribute("disabled");
        return;
      }
      this.currentValue = this.vinInput.value;
      const vinDisplay = this.querySelector(".jsCurrentVinValue");
      if (vinDisplay) vinDisplay.textContent = this.vinInput.value;
      this.classList.remove("active");
      this.submitVin.innerHTML = "Submit";
      this.submitVin.removeAttribute("disabled");
      this.syncVinAttributes();
      this.refreshCartSection();
    }
    async syncVinAttributes() {
      try {
        const resp = await fetch("/cart.js");
        const cart = await resp.json();
        const vins = [...new Set(
          cart.items
            .map((item) => item.properties?.["Vehicle Identification Number"])
            .filter(Boolean)
        )];
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: { "Vehicle Identification Numbers": vins.join(", ") }
          }),
          keepalive: true
        });
      } catch (e) {
      }
    }
  };
  !customElements.get("cart-vin") && customElements.define("cart-vin", CartVehicleIdentification);
})();
